import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0889c4f2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0889c4f2&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=0889c4f2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889c4f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0889c4f2')) {
      api.createRecord('0889c4f2', component.options)
    } else {
      api.reload('0889c4f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0889c4f2&scoped=true", function () {
      api.rerender('0889c4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/whitelist/index.vue"
export default component.exports